module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"testMode":"Put this setup in test mode. (Will not be scheduled)","forwardToSight":"EDI forwarded from R10. Setup will not be scheduled","setupDetails":"EDI Setup"},"no":{"testMode":"Sett i test modus ( Setup blir ikke schedulert )","forwardToSight":"EDI blir videresendt ifra R10. Blir ikke schedulert","setupDetails":"EDI oppsett"}}')
  delete Component.options._Ctor
}
